import { render, staticRenderFns } from "./IconFolderRemoveOutline.vue?vue&type=template&id=26ccef74"
import script from "./IconFolderRemoveOutline.vue?vue&type=script&lang=js"
export * from "./IconFolderRemoveOutline.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports